module.exports = __webpack_public_path__ + "img/bg_课堂实训.b5f695df.png";